// App.js
import React,{ useState }  from "react";
import Dash_Navbar from "../components/dash_Navbar";
import "../App.css";
import DashJobList from "../components/dash_JobList";
import DashSidebar from "../components/dash_sidebar";
import "../styles/dashboard.css";
import { MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";

// import ProfileHeaderr from "./ProfileHeader";
// import ScoreCircle from "../components/dash_score";
// import Dashboard from "../components/dash_scoree";
// import DashboardSidebar from "../components/dashboard_sidebar";
import ProfileHeader from "../components/ProfileHeader"

function Dash() {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate=useNavigate()
  return (
    <>
      <Dash_Navbar setSearchTerm={setSearchTerm}/>     
      {/* Mobile profile header */}
      <div className="mobile-profile-header">
    <div style={{ position: "relative" }}>
        <MdEdit
            onClick={() => navigate("/candidate-onboarding")}
            style={{
                position: "absolute",
                top: 10,
                right: 10,
                fontSize: 22,
                color: "#333",
                zIndex: 20
            }}
        />
        <ProfileHeader />
    </div>

    <p
        onClick={() => navigate("/candidate-profile")}
        style={{
            background: "#4a90e2",
            color: "#fff",
            padding: "10px",
            borderRadius: "8px",
            textAlign: "center",
            marginTop: "15px",
            fontWeight: "600"
        }}
    >
        Update & Complete Profile
    </p>
</div>


    
      {/* <Dashboard/>
      <ScoreCircle/>*/}
 
      {/* <Profile/>
      <DashboardSidebar/> */}
    <div className="dash_layout">

        <div style={{width: "260px" ,}} className="desktop-sidebar">
          <DashSidebar />
        </div>

        <div style={{flex:"1"}}>
          <DashJobList searchTerm={searchTerm}/>
        </div>
    </div>
    </>
  );
}

export default Dash;
